import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import InputTextNested from '../Form/InputTextNested';
import ProvinceInput from '../Form/ProvinceInput.component';
import OfficeIcon from '../../Visuals/Icons/OfficeIcon.icon';

const AddressComponent = ({ billingAddress, setBillingAddress }) => {
  return (
    <>
      <h3>
        Address <OfficeIcon />
      </h3>
      <Suspense fallback={<div>Loading...</div>}>
        <InputTextNested
          title="Street"
          value={billingAddress?.street}
          name="street"
          nestedValue={setBillingAddress}
          upperValue={billingAddress}
          containerClassName="formInputUnderline"
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <InputTextNested
          title="City"
          name="city"
          value={billingAddress?.city}
          upperValue={billingAddress}
          nestedValue={setBillingAddress}
          containerClassName="formInputUnderline"
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <ProvinceInput
          title="Province"
          name="province"
          value={billingAddress?.province}
          upperValue={billingAddress}
          nestedValue={setBillingAddress}
          containerClassName="formInputUnderline"
        />
      </Suspense>
      <Suspense fallback={<div>Loading...</div>}>
        <InputTextNested
          title="Postal Code"
          name="postalCode"
          value={billingAddress?.postalCode}
          upperValue={billingAddress}
          nestedValue={setBillingAddress}
          containerClassName="formInputUnderline"
        />
      </Suspense>
    </>
  );
};
AddressComponent.propTypes = {
  billingAddress: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    province: PropTypes.string,
    postalCode: PropTypes.string,
  }),
  setBillingAddress: PropTypes.func,
};

export default AddressComponent;
